// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevPostalAddressController {
	/* @ngInject */
	constructor() {
		this.settings = {
			placeholder: 'Phone number',
			country: 'FR',
		};
	}
}
